"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownFilter = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _filterInput = require("./filter-input.js");

var _tagPills = require("./tag-pills.js");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FilterByLabel = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "FilterByLabel",
  componentId: "sc-1wa5e1c-0"
})(["&&{display:flex;flex-direction:row;align-items:center;justify-content:center;background:", ";color:", ";white-space:nowrap;padding:8px 24px;}& > ", "{margin-right:8px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.bubbleBlue500;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.white;
}, _baseReactComponents.Icon);

var FilterInputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FilterInputWrapper",
  componentId: "sc-1wa5e1c-1"
})(["@media screen and (", "){overflow:auto;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{width:0;height:0;}}"], function (_ref3) {
  var forLargerThanPhone = _ref3.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var FilterBar = _styledComponents["default"].div.withConfig({
  displayName: "FilterBar",
  componentId: "sc-1wa5e1c-2"
})(["display:flex;flex-direction:row;align-items:center;justify-content:flex-start;overflow:hidden;background:", ";border:2px solid ", ";box-sizing:border-box;border-radius:62px;& > ", "{flex:0 0 auto;display:flex;}"], function (_ref4) {
  var belugaWhite = _ref4.theme.belugaWhite;
  return belugaWhite;
}, function (_ref5) {
  var scuttleGray200 = _ref5.theme.scuttleGray200;
  return scuttleGray200;
}, FilterByLabel);

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1wa5e1c-3"
})(["display:", ";flex-direction:column;align-items:stretch;justify-content:flex-start;@media screen and (", "){display:", ";}"], function (_ref6) {
  var forScreenSize = _ref6.forScreenSize;
  return forScreenSize === 'mobile' || forScreenSize === 'all' ? 'flex' : 'none';
}, function (_ref7) {
  var forLargerThanPhone = _ref7.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, function (_ref8) {
  var forScreenSize = _ref8.forScreenSize;
  return forScreenSize === 'desktop' || forScreenSize === 'all' ? 'flex' : 'none';
});

var Filter = function Filter(_ref9) {
  var _ref9$filters = _ref9.filters,
      filters = _ref9$filters === void 0 ? [] : _ref9$filters,
      _ref9$activeFilters = _ref9.activeFilters,
      activeFilters = _ref9$activeFilters === void 0 ? {} : _ref9$activeFilters,
      _ref9$multiSelectFilt = _ref9.multiSelectFilters,
      multiSelectFilters = _ref9$multiSelectFilt === void 0 ? [] : _ref9$multiSelectFilt,
      _ref9$onChange = _ref9.onChange,
      onChange = _ref9$onChange === void 0 ? function () {} : _ref9$onChange,
      _ref9$onComplete = _ref9.onComplete,
      _onComplete = _ref9$onComplete === void 0 ? function () {} : _ref9$onComplete,
      _ref9$filterByLabel = _ref9.filterByLabel,
      filterByLabel = _ref9$filterByLabel === void 0 ? 'Filter Results' : _ref9$filterByLabel,
      _ref9$filterStepCompl = _ref9.filterStepCompletionLabel,
      filterStepCompletionLabel = _ref9$filterStepCompl === void 0 ? 'Apply Filters' : _ref9$filterStepCompl,
      _ref9$filterStepBackL = _ref9.filterStepBackLabel,
      filterStepBackLabel = _ref9$filterStepBackL === void 0 ? 'Back' : _ref9$filterStepBackL,
      filterStepCloseLabel = _ref9.filterStepCloseLabel,
      _ref9$filterStepConfi = _ref9.filterStepConfirmLabel,
      filterStepConfirmLabel = _ref9$filterStepConfi === void 0 ? 'Apply Filters' : _ref9$filterStepConfi,
      _ref9$filterResetLabe = _ref9.filterResetLabel,
      filterResetLabel = _ref9$filterResetLabe === void 0 ? 'Clear All' : _ref9$filterResetLabe,
      activeFiltersLabel = _ref9.activeFiltersLabel,
      _ref9$forScreenSize = _ref9.forScreenSize,
      forScreenSize = _ref9$forScreenSize === void 0 ? 'all' : _ref9$forScreenSize,
      className = _ref9.className,
      theme = _ref9.theme;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrapper, {
    forScreenSize: forScreenSize,
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(FilterBar, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(FilterByLabel, {
        bold: true,
        size: "xl",
        "data-testid": "dropdown-filter:filter-by",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
          name: "tech/filter",
          color: theme.white,
          height: "24",
          width: "24"
        }), filterByLabel]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterInputWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterInput.FilterInput, {
          filters: filters,
          activeFilters: activeFilters,
          multiSelectFilters: multiSelectFilters,
          filterStepCompletionLabel: filterStepCompletionLabel,
          filterStepCloseLabel: filterStepCloseLabel,
          filterStepConfirmLabel: filterStepConfirmLabel,
          filterStepBackLabel: filterStepBackLabel,
          onChange: onChange,
          onComplete: function onComplete() {
            return _onComplete();
          }
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_tagPills.TagPills, {
      activeFilters: activeFilters,
      activeFiltersLabel: activeFiltersLabel,
      filterResetLabel: filterResetLabel,
      onChange: onChange
    })]
  });
};

var DropdownFilter = (0, _styledComponents["default"])((0, _styledComponents.withTheme)(Filter)).withConfig({
  displayName: "DropdownFilter",
  componentId: "sc-1wa5e1c-4"
})([""]);
exports.DropdownFilter = DropdownFilter;
DropdownFilter.displayName = 'DropdownFilter';
//# sourceMappingURL=index.js.map